import { getSettingFooterInfo } from '@stores/selectors/companyInfo';
import { useAtomValue } from 'jotai';
import { Container, Icon, InfoItem, InfoList, Privacy } from './style';

const Footer = () => {
  const companyInfo = useAtomValue(getSettingFooterInfo);

  return (
    <Container>
      <InfoList>
        <InfoItem>
          <Icon src={'/img/icon_person.png'} />
          {companyInfo.managerName}
        </InfoItem>
        <InfoItem>
          <Icon src={'/img/icon_mail.png'} />
          {companyInfo.managerEmail}
        </InfoItem>
        <InfoItem>
          <Icon src={'/img/icon_call.png'} />
          {companyInfo.managerPhone}
        </InfoItem>
        <InfoItem>
          <Privacy>개인정보 처리 방침</Privacy>
        </InfoItem>
      </InfoList>
    </Container>
  );
};

export default Footer;
